import {
    GET_USER_DATA_BEGIN,
    GET_USER_DATA_SUCCES,
    GET_USER_DATA_FAILURE,
    GET_USER_DATA_LOGOUT,
    GET_USER_ME_BEGIN,
    GET_USER_ME_SUCCES,
    GET_USER_ME_FAILURE,
    GET_USER_RIGHT_BEGIN,
    GET_USER_RIGHT_SUCCES,
    GET_USER_RIGHT_FAILURE,
    GET_ADMIN_TENDANT_BEGIN,
    GET_ADMIN_TENDANT_SUCCES,
    GET_ADMIN_TENDANT_FAILURE,
    USER_LOGOUT
 

  } from '../actions/userActions'; 

  const initialState = {
    user: [],
    userme: [],
    userrights: [],
    admintenants: [],
    loading: false,
    error: null
  };


  export default function getuserdata(state = initialState, action) {
      //console.log("------- User Reducer -----------");
      //console.log(action.type);
      //console.log(action.payload);
      //console.log("------- User Reducer End-----------");

    switch(action.type) {
      case GET_USER_DATA_BEGIN:
        return {
          ...state,
          loading: true,
          error: null
        }; 
    
      case GET_USER_DATA_LOGOUT:
        return {
         ...state,
         user: [],
         
              };
  
      case GET_USER_DATA_SUCCES:
        return {
          ...state,
          user: action.payload.userdata,
          loading: false,
          error: null
        };

      
      case GET_USER_DATA_FAILURE:
          return {
            ...state,
            loading: false,
            error: action.payload.error
            };


      case GET_USER_ME_BEGIN:
            return {
              ...state,
              loading: true,
              error: null
          }; 
        
      case GET_USER_ME_SUCCES:
            return {
              ...state,
              userme: action.payload.userme,
              loading: false,
              error: null
            };
      
            
      case GET_USER_ME_FAILURE:
          return {
            ...state,
            loading: false,
            error: action.payload.error
          };

       case USER_LOGOUT:
            return {
              ...state,
              user: [],
              userme: [],
              loading: false,
              error: null
            };

        case GET_USER_RIGHT_BEGIN:
              return {
                ...state,
                loading: true,
                error: null
            }; 
          
        case GET_USER_RIGHT_SUCCES:
              return {
                ...state,
                userrights: action.payload.userrights,
                loading: false,
                error: null
              };
        
              
        case GET_USER_RIGHT_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.payload.error
            };


        case GET_ADMIN_TENDANT_BEGIN:
              return {
                ...state,
                loading: true,
                error: null
            }; 
          
        case GET_ADMIN_TENDANT_SUCCES:
              return {
                ...state,
                admintenants: action.payload.admintenants,
                loading: false,
                error: null
              };
        
              
        case GET_ADMIN_TENDANT_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.payload.error
            };
  
        default:
        return state;
    }
    
  }